import { e } from "./index865.mjs";
var n = e, r = /ipad|iphone|ipod/i.test(n) && typeof Pebble < "u";
export {
  r as e
};
